import { ChartDataset } from 'chart.js';

export function dataPointLogic(
  index: number,
  rangeSet: number | string,
): boolean {
  const range = typeof rangeSet === 'string' ? parseInt(rangeSet) : rangeSet;
  return index % (range / 5) === 0;
}
export function dataSet(
  data: number[],
  color: string,
  label: string,
): ChartDataset<'line', number[]> {
  return {
    label: label,
    data: data,
    fill: false,
    borderColor: color,
    borderWidth: 1,
    tension: 0,
    pointBackgroundColor: color,
    pointBorderWidth: 0,
  };
}
